import React from 'react';
import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';
import { Box, Drawer as MuiDrawer, ListItemButton } from '@mui/material';
import { SidebarItemsType } from '../../types/sidebar';
import Footer from './SidebarFooter';
import SidebarNav from './SidebarNav';
import StagingLogo from '../../assets/pictures/StagingLogo.png';

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Brand = styled(ListItemButton)<{
  component?: React.ReactNode;
  to?: string;
}>`
  color: var(--color-light-greyish-blue);
  background-color: ${import.meta.env.REACT_APP_BUILD === 'staging'
    ? 'var(--color-staging-navigation)'
    : 'var(--color-deep-ocean-blue)'};
  min-height: 56px;
  justify-content: center;
  cursor: pointer;
  flex-grow: 0;

  &:hover {
    background-color: var(--color-scifree-teal);
  }

  &.Mui-focusVisible {
    background-color: ${import.meta.env.REACT_APP_BUILD === 'staging'
      ? 'var(--color-staging-navigation)'
      : 'var(--color-deep-ocean-blue)'};
  }

  &:focus-visible {
    outline: 2px solid var(--color-white);
    outline-offset: -2px;
  }
`;

export type SidebarProps = {
  PaperProps: {
    style: {
      width: number;
    };
  };
  variant?: 'permanent' | 'persistent' | 'temporary';
  open?: boolean;
  onClose?: () => void;
  pages: SidebarItemsType[];
  showFooter?: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({
  pages,
  showFooter = true,
  ...rest
}) => {
  return (
    <Drawer
      variant="permanent"
      {...rest}
      PaperProps={{
        ...rest.PaperProps,
        'aria-label': 'Main navigation sidebar',
      }}
    >
      <Brand component={NavLink as any} to="/" aria-label="JST home page">
        {import.meta.env.REACT_APP_BUILD === 'staging' ? (
          <img
            src={StagingLogo}
            style={{ width: '140px', marginTop: 10 }}
            alt="SciFree staging logo"
          />
        ) : (
          <Box
            ml={1}
            fontFamily="Helvetica Neue"
            fontWeight={700}
            fontSize={40}
            letterSpacing={1}
          >
            SciFree
          </Box>
        )}
      </Brand>
      <SidebarNav pages={pages} />
      {!!showFooter && <Footer />}
    </Drawer>
  );
};

export default Sidebar;
